import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import AdminLogin from './pages/AdminLogin';
import { AdminEsqueci, AdminRepor } from './pages/AdminRecuperar';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
      <Router>
        <Routes>
          <Route path="/" element={<AdminLogin />} />
          {/* Recuperar a conta de equipa. Fora do ProtectedRoute, como é
              evidente: quem chega aqui é precisamente quem não consegue
              entrar. O caminho é o mesmo do site (/reset-password) para os
              links antigos não partirem. */}
          <Route path="/recuperar" element={<AdminEsqueci />} />
          <Route path="/reset-password" element={<AdminRepor />} />
          <Route 
            path="/admin/*" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
